import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiStatistics } from '@app/packages/api/v2/types/entities'
import { createLoadable, mapThunkSelector } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { routingDateSelector } from './routing'

const statisticsSlice = createReduxSlice<SliceState<ApiStatistics>>('statistics')

export const statisticsResultSelector = createSelector([statisticsSlice.selector, routingDateSelector], (sliceState, date) =>
  createLoadable(c =>
    withCheckedSliceState(c, {
      sliceState,
      slice: statisticsSlice,
      date: { date, expiresInMinutes: 30 },
      load: async dispatch => {
        const { getStatistics } = await import('@app/packages/api/v2/actions/statistics')
        const resp = await dispatch(callV2Api(getStatistics())).catch(catchFetchDataError(dispatch, 'Statistics fetch failed'))
        return resp.data
      },
    })
  )
)

export const roundedSittersNumResultSelectorSelector = mapThunkSelector(statisticsResultSelector, statistics => {
  return Math.floor(statistics.attributes.active_sitters / 100) * 100
})
